import React, { useState, useEffect } from "react";
import { NumberVerify } from "../services/apiServices";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";

const AdminLogin = () => {
  const [step, setStep] = useState("login"); // login | otp
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [serverOtp, setServerOtp] = useState(""); // backend OTP
  const [adminData, setAdminData] = useState({});
  const [loading, setLoading] = useState(false);

  const [resendTime, setResendTime] = useState(16);

  const navigate = useNavigate();

  

  // TIMER for resend OTP
  useEffect(() => {
    if (step === "otp" && resendTime > 0) {
      const timer = setTimeout(() => setResendTime(resendTime - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTime, step]);


  // ============================
  //   SEND OTP (Admin)
  // ============================
  const handleSendOTP = async () => {
    if (phoneNumber.length !== 10) {
      alert("Please enter a valid 10-digit phone number");
      return;
    }

    try {
      setLoading(true);

      const response = await NumberVerify({
        phone: phoneNumber,
        role: "admin",
      });

      const resData = await response.json();
      console.log("Admin Login →", resData);

      if (resData?.status === 200 && resData?.data?.adminInfo) {
        setAdminData(resData?.data?.adminInfo && resData?.data?.adminInfo?.length > 0 ? resData?.data?.adminInfo[0] : {});
        setServerOtp(resData?.otp);
        setStep("otp");
        setResendTime(16);
      } else {
        alert(resData?.message || "Admin not found");
      }
    } catch (error) {
      console.error(error);
      alert("Error sending OTP");
    } finally {
      setLoading(false);
    }
  };


  // ============================
  //   VERIFY OTP
  // ============================
  const handleVerifyOTP = () => {
    if (otp === serverOtp) {
      // Store admin session in localStorage
      localStorage.setItem("loggedAdminInfo", JSON.stringify(adminData));

      navigate("/dashboard");
    } else {
      alert("Invalid OTP");
    }
  };


  // ============================
  //   RESEND OTP
  // ============================
  const handleResendOTP = () => {
    if (resendTime === 0) {
      handleSendOTP();
      setResendTime(16);
    }
  };


  // ======================================================
  //   PAGE UI (LOGIN / OTP)
  // ======================================================
  return (
    <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-blue-600 to-purple-600 px-6">
      <div className="bg-white shadow-xl rounded-xl p-8 max-w-md w-full">

        {/* ================= LOGIN SCREEN ================= */}
        {step === "login" && (
          <>
            <h1 className="text-3xl font-bold text-center text-blue-600">
              Admin Login
            </h1>

            <p className="text-center text-gray-500 mt-2">
              Enter your phone number to receive OTP
            </p>

            <div className="mt-8">
              <label className="text-gray-700 font-medium">Phone Number</label>
              <input
                type="tel"
                maxLength={10}
                className="w-full mt-2 p-3 border rounded-lg"
                placeholder="Enter 10-digit number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>

            <Button
              onClick={handleSendOTP}
              disabled={phoneNumber.length !== 10 || loading}
              className={`w-full mt-6 ${phoneNumber.length === 10
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-gray-300"
                }`}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </Button>
          </>
        )}

        {/* ================= OTP SCREEN ================= */}
        {step === "otp" && (
          <>
            <h1 className="text-3xl font-bold text-center text-blue-600">
              Enter OTP
            </h1>

            <p className="text-center text-gray-500 mt-2">
              OTP sent to +91{phoneNumber}
            </p>

            <input
              type="tel"
              maxLength={6}
              className="w-full mt-6 p-3 border text-center rounded-lg tracking-widest text-xl font-semibold"
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />

            <Button
              onClick={handleVerifyOTP}
              disabled={otp.length !== 6}
              className={`w-full mt-6 ${otp.length === 6
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-gray-300"
                }`}
            >
              Verify OTP
            </Button>

            <button
              onClick={handleResendOTP}
              disabled={resendTime > 0}
              className="w-full mt-4 text-blue-600 text-sm disabled:text-gray-400"
            >
              {resendTime > 0
                ? `Resend OTP in ${resendTime}s`
                : "Resend OTP"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
